import { TranslatorService } from "../../../core/translator/translator.service";
import { PermissionsService } from "../../services/permissions.service";
import { ParametricsService } from "../../services/parametrics.service";
import { StorageService } from "../../services/storage.service";
import { ClientsService } from "../../services/clients.service";
import { FeedersService } from "../../services/feeder.service";
import { GlobalFunction } from "../../services/globalFuntion";
import { HelpService } from "../../../core/help/help.service";
import { FramesService } from "../../services/frames.service";
import { SocketService } from "../../services/socket.service";
import { AlertService } from "../../services/alert.service";
import { PondService } from "../../services/pond.service";
import { FarmService } from "../../services/farm.service";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { debounceTime, takeUntil } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";
import * as moment from "moment";
import {
  ViewEncapsulation,
  TemplateRef,
  Injectable,
  Component,
  OnDestroy,
  ViewChild,
  OnInit
} from "@angular/core";
import { WaterwiseService } from "../../services/waterwise.service";
import { ConfigurationDeviceService } from "../../services/configuration-device.service";
import { HydroDevicesService } from "../hydros/services/devices.service";
import { HydroDevice } from "../hydros/interfaces/device.interface";
import { submitCycle } from "../../Clients/cycles-plantings/interfaces/cycle.interface";
import { CyclesService } from "../../Clients/cycles-plantings/services/cycles.service";

type AlertsSubmenuSection = {
  id: number;
  label: string;
  tableType: number;
  requiresAdmin?: boolean;
};

type AlertsMainSection = {
  id: number;
  label: string;
  viewMode: 1 | 2 | 3 | 4;
  submenu: AlertsSubmenuSection[];
};

type StoredAlertsView = {
  sectionId: number | null;
  tableType: number | null;
};

/** Opciones de orden de la tabla de alertas de alimentadores (ver select "Orden" del template). */
/* Campos que pintan las tablas de historial de alertas (alimentadores y waterwises) */
const ALERT_HISTORY_FIELDS = [
  "id",
  "alert_type",
  "date_created",
  { pond: ["id", "name"] },
  { device: ["id", "name"] }
];
/* Campos que precarga el modal de configuración: valores actuales (individual) y
   velocidad (individual y masiva) */
const SETTINGS_FIELDS = [
  "id",
  "status_version",
  "status_speed",
  "status_high_speed",
  "status_low_speed",
  "status_speed_mode",
  "status_port",
  "status_dispenser_alert",
  "status_dispenser_current",
  "status_sprinkler_current",
  "status_dispenser_sensor",
  "status_sprinkler_sensor"
];
const ALERT_ORDERINGS = [
  "",
  "name_advance",
  "pond_number",
  "pond",
  "-alert_rank",
  "-alert_sprinkle,-alert_comm,-alert_reset,-alert_dispenser"
];

@Component({
  selector: "app-alerts-list",
  templateUrl: "./alerts.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrls: ["./alerts.component.scss"]
})
@Injectable({
  providedIn: "root"
})
export class AlertsAdminComponent implements OnInit, OnDestroy {
  @ViewChild("modal") public ModalTesting;
  @ViewChild("modalBatteryPanel") public modalBatteryPanel;

  private readonly lastViewStorageKey = "alerts-last-view";

  user: any;

  selectedName: string = "";
  selectedTableType: number = 1;

  minimizedFeeders: boolean = true;

  configModal = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    centered: true,
    size: "xl",
    class: "modal-config"
  };

  clients: any = [];
  clientFarms: any = [];
  clientFarmPonds: any = [];

  parametricsAlerts: any = [];
  historicalAlerts: any = [];
  feeders: any = [];
  waterwises: any = [];
  hydros: HydroDevice[] = [];
  sensorsAlerts: any = [];

  selectedItems: any = [];

  kindItems = [
    { value: 1, label: "alerts.parametry.temperature" },
    { value: 2, label: "alerts.parametry.oxygen" },
    { value: 3, label: "alerts.parametry.salinity" }
  ];

  // Panel lateral de filtros secundarios
  openFilters = false;
  /** Llave compartida (`*appFilterItem`) de cada control del panel, para saber cuales estan en la barra. */
  filterKeys: { [control: string]: string } = {
    orderingAdvance: "order",
    typeAlert: "alert_type",
    category: "repeated",
    dateCreated: "dates",
    finishCreated: "dates",
    client_id: "client",
    farm_id: "farm",
    pond_id: "pond"
  };

  FormSearch: FormGroup = new FormGroup({
    client_id: new FormControl(""),
    farm_id: new FormControl(""),
    pond_id: new FormControl(""),
    advanced: new FormControl(""),
    orderingAdvance: new FormControl(""),
    dateCreated: new FormControl(""),
    finishCreated: new FormControl(""),
    typeAlert: new FormControl(""),
    category: new FormControl(""),
    cycle_id: new FormControl(""),
    kind: new FormControl(""),
    filteredBusinessName: new FormControl("")
  });
  searchGraph: FormGroup = new FormGroup({
    resample_rule: new FormControl("W"),
    value_rule: new FormControl(1),
    start_date: new FormControl(""),
    finish_date: new FormControl("")
  });

  pagination = 1;
  pageSize = 30;
  count = 0;

  loadingData: boolean = true;

  ArrayTestMonitor = [];
  ArrayTestBatery = [];
  ArrayTestPanel = [];
  ArrayTestVersion = [];
  ArrayTestSenal = [];

  filteredClients: any = [];

  loadingFormClients = true;
  loadingFormFarms = false;
  loadingFormPonds = false;

  public textQueryAlerts = "";

  farmSubscription: Subscription | undefined;
  modeSubscription: Subscription | undefined;
  socketInfoSubscription: Subscription | undefined;
  private cancelDataRequests$ = new Subject<void>();
  /* Cancela la carga de estanques anterior al cambiar de granja rápido */
  private cancelPondsRequests$ = new Subject<void>();

  cycles: submitCycle[] = [];

  feedersHome = [];
  alerts_table_type = 1;

  permissions = {
    view_tests: true,
    view_parametric: true,
    change_alert: true
  };
  viewModalTestDevice = false;
  /* 1 feeders 2 waterwise 3 parametry */
  view_mode: 1 | 2 | 3 | 4 = 1;

  sections: AlertsMainSection[] = [
    {
      id: 1,
      label: "general.feeders",
      viewMode: 1,
      submenu: [
        { id: 101, label: "tables.devices", tableType: 1 },
        {
          id: 102,
          label: "admin.alerts.alerts-history-short",
          tableType: 2,
          requiresAdmin: true
        }
      ]
    },
    {
      id: 2,
      label: "Waterwises",
      viewMode: 2,
      submenu: [
        { id: 201, label: "tables.devices", tableType: 4 },
        {
          id: 202,
          label: "admin.alerts.alerts-history-short",
          tableType: 6,
          requiresAdmin: true
        },
        {
          id: 203,
          label: "admin.alerts.sensor-alert",
          tableType: 5
        }
      ]
    },
    {
      id: 3,
      label: "admin.alerts.parametrics",
      viewMode: 3,
      submenu: [{ id: 301, label: "alerts.general.historical-alerts", tableType: 3 }]
    }
  ];
  section: AlertsSubmenuSection = this.sections[0].submenu[0];
  /* Indica que se está precargando la configuración del alimentador */
  loadingSettings = false;

  constructor(
    public permissionsService: PermissionsService,
    public translatorService: TranslatorService,
    public parametryService: ParametricsService,
    public cycleService: CyclesService,
    public storageService: StorageService,
    public globalFunction: GlobalFunction,
    public feedersService: FeedersService,
    public clientService: ClientsService,
    public framesService: FramesService,
    public socketService: SocketService,
    public alertsService: AlertService,
    public helpService: HelpService,
    public farmService: FarmService,
    public pondService: PondService,
    private modalService: NgbModal,
    public waterwiseService: WaterwiseService,
    public configurationDeviceService: ConfigurationDeviceService,
    private hydroDevicesService: HydroDevicesService
  ) {
    /* Hidrófonos solo para quien tiene el permiso admin_hydros (mismo criterio que el sidebar) */
    if (this.storageService.hasAdminHydrosPermission()) {
      this.sections.push({
        id: 4,
        label: "admin.alerts.hydros",
        viewMode: 4,
        submenu: [{ id: 401, label: "tables.devices", tableType: 7 }]
      });
    }
    window.addEventListener("beforeunload", (e) => {
      if (this.farmSubscription) {
        this.farmSubscription.unsubscribe();
      }
      if (this.socketInfoSubscription) {
        this.socketInfoSubscription.unsubscribe();
      }
      if (this.modeSubscription) {
        this.modeSubscription.unsubscribe();
      }
      this.saveValuePreference();
    });
  }

  ngOnDestroy(): void {
    this.saveValuePreference();
    this.cancelDataRequests$.next();
    this.cancelDataRequests$.complete();
    this.cancelPondsRequests$.next();
    this.cancelPondsRequests$.complete();
    this.farmSubscription?.unsubscribe();
    this.socketInfoSubscription?.unsubscribe();
    this.modeSubscription?.unsubscribe();
  }

  private getStoredLastView(): StoredAlertsView | null {
    const lastView = localStorage.getItem(this.lastViewStorageKey);

    if (!lastView) {
      return null;
    }

    try {
      const parsedValue = JSON.parse(lastView);

      return {
        sectionId: parsedValue.sectionId ? Number(parsedValue.sectionId) : null,
        tableType: parsedValue.tableType ? Number(parsedValue.tableType) : null
      };
    } catch (error) {
      localStorage.removeItem(this.lastViewStorageKey);
      return null;
    }
  }

  private syncCurrentSection(tableType: number, sectionId?: number | null) {
    let selectedSection: AlertsSubmenuSection | null = null;
    let resolvedViewMode: 1 | 2 | 3 | 4 = 1;

    this.sections.some((section) => {
      /* Manda el tipo de tabla: un sectionId guardado que no le corresponde (vista vieja)
         dejaba resaltada otra pestaña y se volvia a guardar mal */
      const submenuItem = section.submenu?.find((sub: AlertsSubmenuSection) => {
        return Number(sub.tableType) === Number(tableType);
      });

      if (submenuItem) {
        selectedSection = submenuItem;
        resolvedViewMode = section.viewMode;
        return true;
      }

      return false;
    });

    this.section = selectedSection ? selectedSection : this.sections[0].submenu[0];
    this.view_mode = resolvedViewMode;
  }

  private persistLastView() {
    localStorage.setItem(
      this.lastViewStorageKey,
      JSON.stringify({
        sectionId: this.section?.id,
        tableType: this.selectedTableType,
        viewMode: this.view_mode
      })
    );
  }

  saveValuePreference() {
    const { client_id, farm_id, typeAlert, pond_id, orderingAdvance, category } =
      this.FormSearch.value;

    let obj = {
      client_id,
      farm_id,
      typeAlert,
      pond_id,
      orderingAdvance,
      category,
      feeder_home: this.feedersHome,
      alerts_table_type: this.alerts_table_type,
      alert_view_mode: this.view_mode
    };

    this.storageService.saveQueryFilters(obj);
    this.persistLastView();
  }

  ngOnInit(): void {
    const validate_permissions = () => {
      const validate_subclient = (prop: string) => {
        return this.permissionsService.validatePermissionsExistSubclient(prop);
      };
      this.permissions = {
        view_tests: validate_subclient("view_tests"),
        view_parametric: validate_subclient("view_parametric"),
        change_alert: validate_subclient("change_alert")
      };
    };

    validate_permissions();

    const setFormValue = (mode: number | string) => {
      const lastView = this.getStoredLastView();
      let getQuery = this.storageService.getQueryFilters({
        ...this.FormSearch.value,
        feeder_home: [],
        alerts_table_type: "",
        alert_view_mode: ""
      });

      this.feedersHome = getQuery.feeder_home ? getQuery.feeder_home : [];

      this.view_mode = getQuery.alert_view_mode ? getQuery.alert_view_mode : 1;
      this.alerts_table_type = getQuery.alerts_table_type ? getQuery.alerts_table_type : 1;

      for (const key in getQuery) {
        if (this.FormSearch.value.hasOwnProperty(key)) {
          this.FormSearch.controls[key].setValue(getQuery[key]);
        }
      }
      // El orden se comparte en preferencias con otras pantallas: si no es una opcion de alertas se quita
      if (!ALERT_ORDERINGS.includes(this.FormSearch.controls["orderingAdvance"].value)) {
        this.FormSearch.controls["orderingAdvance"].setValue("");
      }

      let pond_id = "";
      if (getQuery.pond_id) {
        pond_id = getQuery.pond_id ? getQuery.pond_id : "";
      }

      const restoredTableType = getQuery.alerts_table_type
        ? Number(getQuery.alerts_table_type)
        : lastView?.tableType;

      if (restoredTableType) {
        const type = Number(restoredTableType);
        if (type === 1) {
          this.FormSearch.controls["dateCreated"].setValue("");
          this.FormSearch.controls["finishCreated"].setValue("");
        }

        this.selectedTableType = type;
        this.changeTableType(type, lastView?.sectionId);
      } else {
        this.changeTableType(this.selectedTableType);
      }

      if (!this.storageService.isAdmin() || mode === 1) {
        if (getQuery.client_id) {
          delete getQuery.client_id;
        }
        const { farm_id } = this.storageService.localValue;

        if (farm_id) {
          this.FormSearch.controls["farm_id"].setValue(farm_id);

          if (this.selectedTableType !== 3) {
            this.selectedFarm(farm_id, 2, pond_id);
          }
          this.selectedClient(this.user.id);
        }
      }

      if (this.storageService.isAdmin() || mode === 0) {
        this.getClients();
        if (!getQuery.client_id && !getQuery.farm_id) {
          this.FormSearch.controls["pond_id"].setValue("");
        }
        if (!getQuery.client_id) {
          this.FormSearch.controls["pond_id"].setValue("");
          this.FormSearch.controls["farm_id"].setValue("");
        }
        if (!getQuery.farm_id) {
          this.FormSearch.controls["pond_id"].setValue("");
          this.clientFarmPonds = [];
        }
        if (getQuery.client_id) {
          this.selectedClient(getQuery.client_id);
        }
        if (getQuery.farm_id) {
          if (this.selectedTableType !== 3) {
            this.selectedFarm(getQuery.farm_id, 2, pond_id);
          }
        }
      }

      if (this.selectedTableType === 3) {
        if (this.storageService.isAdmin()) {
          this.getData();
        } else {
          this.selectedFarmParametry();
        }
      } else {
        this.getData();
      }
    };
    if (this.storageService.localValue) {
      const personal_web = this.storageService.localValue;

      const localUser = localStorage.getItem("USER");
      const user = localUser ? <any>JSON.parse(localUser) : {};
      this.user = user;

      setFormValue(personal_web.mode);
    }

    let input = ["advanced"];

    input.forEach((element) => {
      this.FormSearch.controls[element].valueChanges.pipe(debounceTime(700)).subscribe((search) => {
        this.getData();
      });
    });

    this.farmSubscription = this.storageService.watchStorage("farmId").subscribe((farm_id) => {
      this.FormSearch.controls["farm_id"].setValue(farm_id);
      this.FormSearch.controls["pond_id"].setValue("");
      const { mode } = this.storageService.localValue;

      if (!this.storageService.isAdmin() || mode === 1) {
        this.FormSearch.controls["farm_id"].setValue(farm_id);
        this.FormSearch.controls["pond_id"].setValue("");
        if (this.selectedTableType === 6) {
          this.selectedFarmParametry();
        } else {
          this.selectedFarm(farm_id, 1);
        }
      }
      validate_permissions();
    });

    this.modeSubscription = this.storageService.watchStorage("mode").subscribe((mode) => {
      setFormValue(mode);
    });
    this.socketInfoSubscription = this.storageService
      .watchStorage("socket")
      .subscribe((msg: any) => {
        if (msg.data) {
          let result = this.globalFunction.setDataFeeders(this.feeders, msg);
          this.feeders = [...result.feeders];
        }
      });

  }

  public getClients = () => {
    this.loadingFormClients = true;
    const fields = ["id", "name"];
    this.clientService.getClients(`?fields=${fields}`).subscribe((clients) => {
      this.loadingFormClients = false;
      this.clients = clients;
    });
  };

  selectedClient(id: any) {
    this.clientFarms = [];
    this.clientFarmPonds = [];
    this.pagination = 1;

    this.loadingFormFarms = true;
    this.FormSearch.controls["client_id"].setValue(id);
    if (id) {
      if (this.storageService.isAdmin()) {
        const fields = ["id", "name"];

        this.clientService.getClientFarms(`?fields=${fields}`, id).subscribe((farms) => {
          this.loadingFormFarms = false;
          this.clientFarms = farms;
        });
      } else {
        this.FormSearch.controls["client_id"].setValue("");
        const fields = ["id", "name"];
        const query = `?client=${id}&fields=${fields}`;
        this.farmService.getFarms(query).subscribe((resp) => {
          this.loadingFormFarms = false;
          this.clientFarms = resp;
        });
      }
    } else {
      this.loadingFormFarms = false;
    }
  }

  selectedFarm = async (id, pase, pond?) => {
    this.pagination = 1;
    const fields = ["id", "name", "number"];
    pond && this.FormSearch.controls["pond_id"].setValue(pond);
    if (id !== "") {
      this.loadingFormPonds = true;
      const { name_query } = this.storageService.getQueryFilters({
        name_query: ""
      });
      // Lista del filtro: sin orden por alertas (`alert_count` es una anotacion cara)
      const alert = "";
      const name = name_query ? `name_advance` : "number";

      const object_query = {
        farm_id: id,
        fields,
        all_records: id ? true : false,
        ordering: alert + name
      };
      const query = this.globalFunction.constructQuery(object_query);
      /* La tabla no depende de la lista de estanques: se piden en paralelo */
      const tableRequest = Number(pase) === 1 ? this.getData() : Promise.resolve();
      this.cancelPondsRequests$.next();
      try {
        const ponds = await this.pondService
          .getPonds(query)
          .pipe(takeUntil(this.cancelPondsRequests$))
          .toPromise();
        if (ponds) {
          this.loadingFormPonds = false;
          this.clientFarmPonds = ponds;
        }
      } catch (error) {
        this.loadingFormPonds = false;
      }
      await tableRequest;
    } else {
      this.clientFarmPonds = [];
      pase == 1 && this.getData();
    }
  };

  onClientSelected(client: any) {
    if (client) {
      this.FormSearch.controls["client_id"].setValue(client.id);
      this.FormSearch.controls["farm_id"].setValue("");
      this.FormSearch.controls["pond_id"].setValue("");
      this.selectedClient(client.id);
    } else {
      // Se limpió la selección
      this.FormSearch.controls["client_id"].setValue("");
      this.FormSearch.controls["farm_id"].setValue("");
      this.FormSearch.controls["pond_id"].setValue("");
      this.clientFarms = [];
      this.clientFarmPonds = [];
    }
    this.getData();
  }

  getSoloPonds = async () => {
    this.loadingFormPonds = true;
    const fields = ["id", "name", "number"];
    const { farm_id } = this.FormSearch.value;
    const { name_query } = this.storageService.getQueryFilters({
      name_query: ""
    });
    // Lista del filtro: sin orden por alertas (`alert_count` es una anotacion cara)
    const alert = "";
    const name = name_query ? `name_advance` : "number";

    const object_query = {
      farm_id,
      fields,
      all_records: true,
      ordering: alert + name
    };

    const query = this.globalFunction.constructQuery(object_query);
    this.cancelPondsRequests$.next();
    let ponds;
    try {
      ponds = await this.pondService
        .getPonds(query)
        .pipe(takeUntil(this.cancelPondsRequests$))
        .toPromise();
    } catch (error) {
      this.loadingFormPonds = false;
    }
    if (ponds) {
      const pond = this.FormSearch.controls["pond_id"].value;
      this.clientFarmPonds = ponds;
      this.loadingFormPonds = false;
      if (pond) {
        const exist = ponds.some((item) => Number(item.id) === Number(pond));

        this.clientFarmPonds = ponds;
        this.loadingFormPonds = false;
        // Sin esperar 300ms: el formulario reactivo no depende de que se pinten las opciones
        if (!exist) {
          if (ponds.length > 0) {
            this.FormSearch.controls["pond_id"].setValue(ponds[0].id);
          }
        } else {
          this.FormSearch.controls["pond_id"].setValue(pond);
        }
      }
    }
  };

  selectedFarmParametry = async () => {
    this.pagination = 1;
    this.loadingFormPonds = true;
    if (!this.storageService.isAdmin()) {
      await this.getCycles(true);
    }
  };

  changeCycleSelect = () => {
    this.pagination = 1;
    const { farm_id, cycle_id } = this.FormSearch.value;
    this.loadingFormPonds = true;
    const fields = ["id", "name", "number"];
    this.FormSearch.controls["pond_id"].setValue("");
    const { name_query } = this.storageService.getQueryFilters({
      name_query: ""
    });
    // Lista del filtro: sin orden por alertas (`alert_count` es una anotacion cara)
    const alert = "";
    const name = name_query ? `name_advance` : "number";
    const object_query = {
      farm_id,
      fields,
      cycle_id,
      ordering: alert + name
    };

    const query = this.globalFunction.constructQuery(object_query);

    this.pondService.getPonds(query).subscribe((ponds) => {
      this.clientFarmPonds = ponds;
      this.loadingFormPonds = false;
      // Un ciclo sin estanques no debe romper la pantalla
      this.FormSearch.controls["pond_id"].setValue(ponds.length > 0 ? ponds[0].id : "");
      this.getData();
    });
  };

  selectedPond = async (pond: any) => {
    this.FormSearch.controls["pond_id"].setValue(pond ? pond.id : "");
    this.pagination = 1;
    await this.getData();
  };
  getCycles = async (get_ponds = false) => {
    const { farm_id } = this.FormSearch.value;
    const object_query = {
      farm_id,
      ordering: `-start_date`
    };
    const query = this.globalFunction.constructQuery(object_query);
    const cycles = await this.cycleService.getCycles(query).toPromise();
    this.cycles = cycles;

    if (cycles.length > 0) {
      this.FormSearch.controls["cycle_id"].setValue(cycles[0].id);
      if (get_ponds) {
        const fields = ["id", "name", "number"];
        const { name_query } = this.storageService.getQueryFilters({
          name_query: ""
        });
        // Lista del filtro: sin orden por alertas (`alert_count` es una anotacion cara)
        const alert = "";
        const name = name_query ? `name_advance` : "number";

        const { farm_id } = this.FormSearch.value;
        const object_query = {
          farm_id,
          fields,
          cycle_id: this.FormSearch.value.cycle_id,
          ordering: alert + name
        };
        const query_ponds = this.globalFunction.constructQuery(object_query);

        const ponds = await this.pondService.getPonds(query_ponds).toPromise();
        if (ponds) {
          this.clientFarmPonds = ponds;
          this.loadingFormPonds = false;
          this.FormSearch.controls["pond_id"].setValue(ponds.length > 0 ? ponds[0].id : "");
          this.getData();
        }
      }
    }
  };

  generateValueQueryDate() {
    const { dateCreated, finishCreated } = this.FormSearch.value;

    let finish: any = moment(dateCreated).add(1, "d");
    let yesterday = moment(finish._d).format("YYYY-MM-DD");
    return dateCreated ? `${dateCreated},${finishCreated ? finishCreated : yesterday}` : "";
  }

  validateOrdering = () => {
    let query = "";
    const { orderingAdvance } = this.FormSearch.value;
    let string = orderingAdvance;
    if (this.textQueryAlerts) {
      let order = this.textQueryAlerts[0];
      let caracter = this.textQueryAlerts.slice(1);
      if (order === "-" && string == caracter) {
        string = "";
      }
    }
    let data = [this.textQueryAlerts, string];

    let array = data.filter((item, index) => {
      return data.indexOf(item) === index && item;
    });
    query += array.toString();
    return query;
  };
  public getData = async () => {
    this.cancelDataRequests$.next();

    const actions: { [key: number]: () => void } = {
      1: this.getFeeders,
      2: this.getAlerts,
      3: this.getParametricsAlerts,
      4: this.getWaterwises,
      5: this.getWaterwiseSensorNotifications,
      6: this.getWaterwiseAlerts,
      7: this.getHydros
    };

    const action = actions[this.selectedTableType];

    if (action) {
      await action.call(this);
    }

    this.saveValuePreference();
  };
  getFeeders = async () => {
    this.feeders = [];
    this.loadingData = true;

    /* Campos de la tabla y sus tooltips; el panel lateral, el modal de configuración
       y el panel de comandos (gateway) piden los suyos al abrirse */
    const fields = [
      "id",
      "name",
      "mac",
      { client: ["id", "name", "organization"] },
      { farm: ["id", "name", "timezone"] },
      { pond: ["id", "name"] },
      "status_power",
      "status_battery",
      "status_panel",
      "status_ration",
      "status_db",
      "status_version",
      "status_datetime",
      "status_dispenser",
      "status_dispenser_opening",
      "status_sprinkler",
      "status_speed_mode",
      "alert_dispenser",
      "alert_dispenser_opening",
      "alert_sprinkle",
      "sprinkler_alerts",
      "alert_comm",
      "alert_reset",
      "alert_battery",
      "alert_panel",
      { feeding_details: ["fail_reason"] }
    ];
    const { advanced, pond_id, client_id, farm_id, typeAlert, category } = this.FormSearch.value;
    const object_query = {
      page: this.pagination,
      page_size: this.pageSize,
      fields,
      client_id,
      farm_id,
      pond_id,
      advanced,
      ordering: this.validateOrdering()
    };
    
    const query = this.globalFunction.constructQuery(object_query);

    try {
      let resp = await this.feedersService
        .ListFeedersQuery(query)
        .pipe(takeUntil(this.cancelDataRequests$))
        .toPromise();
      if (resp) {
        this.loadingData = false;
        this.feeders = resp.results.map((item) => {
          const isSelected = this.selectedItems.some((selected) => selected.id === item.id);
          return { ...item, status: isSelected };
        });
        this.feeders.map((obj: any) => (obj.isCollapsed = true));
        this.count = resp.count;

        if (this.storageService.isAdmin()) {
          let all_feeders = [...this.selectedItems, ...this.feeders];
          let feeders = this.duplicate(all_feeders);
          this.socketService.setFeedersSocket(feeders);
        }
      }
    } catch (error) {
      this.loadingData = false;
    }
  };
  getAlerts = async () => {
    this.loadingData = true;
    this.historicalAlerts = [];

    const { advanced, pond_id, client_id, farm_id, typeAlert, category } = this.FormSearch.value;
    const object_query = {
      page: this.pagination,
      page_size: this.pageSize,
      device_type: "feeder",
      client_id,
      farm_id,
      pond_id,
      advanced,
      date: this.generateValueQueryDate(),
      type: typeAlert,
      ordering: ["-date", this.textQueryAlerts].filter(Boolean).join(","),
      category,
      fields: ALERT_HISTORY_FIELDS
    };
    const query = this.globalFunction.constructQuery(object_query);

    this.alertsService
      .getAlerts(query)
      .pipe(takeUntil(this.cancelDataRequests$))
      .subscribe(
        (res) => {
          this.loadingData = false;
          this.historicalAlerts = res.results;
          this.count = res.count;
        },
        (error: any) => {
          /* Sin esto el loader de la tabla se queda activo si la petición falla */
          this.loadingData = false;
        }
      );
  };
  getWaterwises = async () => {
    this.feeders = [];
    this.loadingData = true;
    const { advanced, pond_id, client_id, farm_id, typeAlert } = this.FormSearch.value;

    const object_query = {
      page: this.pagination,
      page_size: this.pageSize,
      client: client_id,
      farm: farm_id,
      pond: pond_id,
      advanced,
      ordering: this.validateOrdering()
    };
    const query = this.globalFunction.constructQuery(object_query);

    try {
      let resp = await this.waterwiseService
        .getWaterwises(query)
        .pipe(takeUntil(this.cancelDataRequests$))
        .toPromise();
      if (resp) {
        this.loadingData = false;
        this.waterwises = resp.results.map((item) => {
          const isSelected = this.selectedItems.some((selected) => selected.id === item.id);
          return { ...item, status: isSelected };
        });
        this.count = resp.count;
      }
    } catch (error) {
      this.loadingData = false;
    }
  };
  /**
   * Obtiene la pagina de hidrófonos con los filtros de la pantalla.
   * Backend hoy solo aplica farm_id y pond_id; client_id y name se envian para cuando los soporte.
   * @returns Promesa que resuelve al terminar la carga.
   */
  getHydros = async () => {
    this.hydros = [];
    this.loadingData = true;
    const { advanced, pond_id, client_id, farm_id } = this.FormSearch.value;
    const query = this.globalFunction.constructQuery({
      page: this.pagination,
      page_size: this.pageSize,
      client_id,
      farm_id,
      pond_id,
      name: advanced
    });

    try {
      const resp = await this.hydroDevicesService
        .list(query)
        .pipe(takeUntil(this.cancelDataRequests$))
        .toPromise();
      /* Si la peticion se cancelo por otra nueva, no se toca el loader de la nueva */
      if (resp) {
        this.loadingData = false;
        this.hydros = resp.results || [];
        this.count = resp.count || 0;
      }
    } catch (error) {
      this.loadingData = false;
      this.hydros = [];
    }
  };
  getWaterwiseSensorNotifications = async () => {
    this.feeders = [];
    this.loadingData = true;
    const { advanced, pond_id, client_id, farm_id, typeAlert } = this.FormSearch.value;

    const object_query = {
      page: this.pagination,
      page_size: this.pageSize,
      farm_id,
      pond_id,
      client_id,
      advanced,
      ordering: ["-created_at", this.validateOrdering()].filter(Boolean).join(",")
    };
    const query = this.globalFunction.constructQuery(object_query);

    try {
      let resp = await this.waterwiseService
        .getWaterwiseSensorNotifications(query)
        .pipe(takeUntil(this.cancelDataRequests$))
        .toPromise();

      if (resp) {
        this.loadingData = false;

        this.sensorsAlerts = resp.results.map((item) => {
          return { ...item, status: false };
        });
        this.count = resp.count;
      }
    } catch (error) {
      this.loadingData = false;
    }
  };

  getWaterwiseAlerts = () => {
    this.loadingData = true;
    this.historicalAlerts = [];

    const { advanced, pond_id, client_id, farm_id, typeAlert } = this.FormSearch.value;

    const ordering = ["-date", this.textQueryAlerts].filter(Boolean).join(",");

    const object_query = {
      page: this.pagination,
      page_size: this.pageSize,
      device_type: "waterwise",
      farm_id,
      pond_id,
      client_id,
      advanced,
      ordering,
      date: this.generateValueQueryDate(),
      type: typeAlert,
      fields: ALERT_HISTORY_FIELDS
    };

    const query = this.globalFunction.constructQuery(object_query);

    this.waterwiseService
      .getWaterwiseAlerts(query)
      .pipe(takeUntil(this.cancelDataRequests$))
      .subscribe(
        (res) => {
          this.loadingData = false;
          this.historicalAlerts = res.results;
          this.count = res.count;
        },
        (error: any) => {
          /* Sin esto el loader de la tabla se queda activo si la petición falla */
          this.loadingData = false;
        }
      );
  };

  getParametricsAlerts = () => {
    this.loadingData = true;
    this.parametricsAlerts = [];

    const { pond_id, client_id, farm_id, kind, cycle_id } = this.FormSearch.value;

    const object_query = {
      page: this.pagination,
      page_size: this.pageSize,
      farm_id,
      pond_id,
      client_id,
      range_date: this.generateValueQueryDate(),
      kind,
      cycle_id,
      ordering: `-created`
    };
    const query = this.globalFunction.constructQuery(object_query);

    this.parametryService
      .getParametricsAlerts(query)
      .pipe(takeUntil(this.cancelDataRequests$))
      .subscribe(
        (res) => {
          this.loadingData = false;
          this.parametricsAlerts = res.results ? res.results : res;
          this.parametricsAlerts.map((obj: any) => (obj.isCollapsed = true));
          this.count = res.count;
        },
        (error: any) => {
          /* Sin esto el loader de la tabla se queda activo si la petición falla */
          this.loadingData = false;
        }
      );
  };

  getlistpagination(page: number) {
    this.pagination = page;
    this.getData();
  }
  /**
   * Controles del panel lateral de filtros visibles en la tabla actual. El
   * ciclo no se incluye porque siempre tiene un valor seleccionado. Para
   * clientes la granja viene del selector del header, asi que no se toca.
   * @returns Nombres de los controles secundarios de FormSearch.
   */
  get secondaryFilters(): string[] {
    const byTable: { [type: number]: string[] } = {
      1: ["orderingAdvance"],
      2: ["typeAlert", "category", "dateCreated", "finishCreated"]
    };
    const dates = this.selectedTableType !== 1 ? ["dateCreated", "finishCreated"] : [];
    const table = byTable[this.selectedTableType] || dates;
    if (!this.storageService.isAdmin()) return [...table, "pond_id"];
    return [...table, "client_id", "farm_id", "pond_id"];
  }

  /**
   * Cantidad de filtros del panel lateral con valor, para el badge del boton. Los
   * que el usuario muestra en la barra no cuentan porque ya estan a la vista.
   * @returns Numero de filtros secundarios activos.
   */
  get activeFilters(): number {
    return this.secondaryFilters.filter((control) => {
      if (this.storageService.isFilterVisible(this.filterKeys[control])) return false;
      return !!this.FormSearch.controls[control].value;
    }).length;
  }

  /**
   * Limpia los filtros del panel lateral y recarga la tabla una sola vez.
   * @returns void
   */
  clearFilters(): void {
    this.secondaryFilters.forEach((key) => {
      this.FormSearch.controls[key].setValue("", { emitEvent: false });
    });
    // Para admin la granja y el estanque dependen del cliente elegido
    if (this.storageService.isAdmin()) {
      this.clientFarms = [];
      this.clientFarmPonds = [];
    }
    this.pagination = 1;
    this.getData();
  }

  setValueOrderinAdvance(target: any) {
    this.getData();
  }

  changeSize(value: number) {
    this.pageSize = value;
    this.getData();
  }

  changeOrdering(value: string) {
    this.textQueryAlerts = value || "";
    this.FormSearch.controls["orderingAdvance"].setValue("");
    this.pagination = 1;
    this.getData();
  }

  /**
   * Subtitulo de la pantalla segun la seccion.
   * @returns clave i18n del subtitulo.
   */
  subtitleKey(): string {
    return Number(this.selectedTableType) === 7
      ? "alerts.home.hydro-subtitle"
      : "alerts.home.subtitle";
  }

  /**
   * Etiqueta del buscador segun la seccion: en hidrófonos solo se busca por nombre.
   * @returns clave i18n de la etiqueta.
   */
  searchLabelKey(): string {
    if (Number(this.selectedTableType) === 7) {
      return "tables.name";
    }
    return this.storageService.isAdmin()
      ? "alerts.home.filter-name-admin"
      : "alerts.home.filter-name";
  }

  changeTableType(selected: number, sectionId?: number | null) {
    if (this.selectedTableType !== selected) {
      this.pagination = 1;
    }

    this.selectedTableType = selected;
    this.syncCurrentSection(selected, sectionId);
    this.selectedItems = [];
    this.textQueryAlerts = "";
    this.alerts_table_type = selected;
    const tableConfig: {
      [key: number]: { nameKey: string; modalSize?: string };
    } = {
      1: { nameKey: "alerts.general.feeder-alerts", modalSize: "xl" },
      2: { nameKey: "alerts.general.historical-alerts", modalSize: "lg" },
      3: { nameKey: "alerts.general.parametry-alerts", modalSize: "md" },
      4: { nameKey: "alerts.general.waterwise-alerts", modalSize: "md" },
      5: { nameKey: "alerts.general.notification-waterwise-alerts" },
      6: { nameKey: "alerts.general.historical-alerts" },
      7: { nameKey: "alerts.general.hydro-alerts" }
    };

    const config = tableConfig[selected];

    if (config) {
      this.selectedName = this.translatorService.translate(config.nameKey);
      if (config.modalSize) {
        this.configModal.size = config.modalSize;
      }
    }

    this.persistLastView();
  }

  removeDevice(device: any) {
    let removeIndex = this.selectedItems
      .map((item) => {
        return item.id;
      })
      .indexOf(device);
    let index = this[this.selectedTableType === 1 ? "feeders" : "waterwises"]
      .map((item) => {
        return item.id;
      })
      .indexOf(device);
    if (index >= 0) {
      this[this.selectedTableType === 1 ? "feeders" : "waterwises"][index].status = false;
    }
    this.selectedItems.splice(removeIndex, 1);
  }

  resetFeeders(array) {
    if (array.length > 0) {
      let query = `?id_in=${array.map((item) => item.id)}`;
      this.framesService.Frame("reset", query).subscribe((resp) => {});
    }
  }

  validateSelectFeeders() {
    let boolean = false;

    if (this.selectedItems.length > 0) {
      boolean = this.selectedItems.some((item) => item.status);
    }
    return boolean;
  }

  /**
   * Abre o cierra un modal. Al cerrar, respeta la configuración de mantener equipos seleccionados.
   * @param template Template del modal a mostrar.
   * @param type "show" para abrir, "hide" para cerrar.
   */
  Modal = (template: TemplateRef<any>, type: "show" | "hide") => {
    switch (type) {
      case "show":
        this.modalService.open(template, this.configModal);
        break;
      case "hide":
        const shouldKeepSelected = this.storageService.localValue.keep_devices_selected;
        if (!shouldKeepSelected) {
          this.resetSelected();
        }
        this.modalService.dismissAll();
        break;
      default:
    }
  };
  viewModalPanel = false;

  showPanelAlerts() {
    if (this.selectedTableType == 1) {
      this.viewModalPanel = true;
    }
    if (this.selectedTableType == 4) {
      this.viewModalTestDevice = true;
    }
  }
  /**
   * Abre el modal de configuración de alimentadores. Antes pide, en una sola petición,
   * los valores de configuración y velocidad de los seleccionados, que no vienen en la lista.
   * @param template Modal a abrir.
   * @param size Tamaño del modal.
   */
  async openSettingsModal(template: TemplateRef<any>, size = "xl") {
    if (this.selectedTableType == 1 && this.selectedItems.length > 0) {
      const ids = this.selectedItems.map((item) => item.id);
      this.loadingSettings = true;
      try {
        const query = this.globalFunction.constructQuery({
          id_in: ids.join(","),
          page_size: ids.length,
          fields: SETTINGS_FIELDS
        });
        const resp: any = await this.feedersService.ListFeedersQuery(query).toPromise();
        const rows = Array.isArray(resp) ? resp : resp && resp.results ? resp.results : [];
        this.selectedItems = this.selectedItems.map((item) => {
          const detail = rows.find((row) => row.id === item.id);
          return detail ? { ...item, ...detail } : item;
        });
      } catch (error) {
        /* Si falla se abre con los datos de la lista; el modal permite configurar igual */
      }
      this.loadingSettings = false;
    }
    this.showModal(template, size);
  }

  showModal(template: TemplateRef<any>, size = "xl") {
    this.modalService.open(template, {
      backdrop: true,
      keyboard: false,
      windowClass: size == "xl" ? "modal-test" : "",
      size: size
    });
  }

  getItemsStatus(value: any, type: "feeder" | "waterwise" = "feeder") {
    this.selectedItems.forEach((element: any, idx: number) => {
      if (element.id === value.id) {
        this.selectedItems.splice(idx, 1, value);
      }
    });
    this.selectedItems.push(value);

    this.selectedItems = this.duplicate(this.selectedItems).filter((item) => {
      return item.status;
    });
    if (type === "feeder") {
      let all_feeders = [...this.selectedItems, ...this.feeders];
      let feeders = this.duplicate(all_feeders);
      this.socketService.setFeedersSocket(feeders);
    }
  }
  duplicate = (feeders) => {
    let hash = {};
    let array = feeders.filter((current) => {
      let exists = !hash[current.id];
      hash[current.id] = true;
      return exists;
    });
    return array;
  };

  changeAll(status: boolean, type: "feeder" | "waterwise" = "feeder") {
    console.log(status);

    this.selectedItems = this.globalFunction.validateRepeat(
      this.selectedItems,
      type === "feeder" ? this.feeders : this.waterwises,
      status
    );
    if (type === "feeder") {
      let all_feeders = [...this.selectedItems, ...this.feeders];
      let feeders = this.duplicate(all_feeders);
      this.socketService.setFeedersSocket(feeders);
    }
  }

  resetSelected() {
    this.selectedItems = [];
    this[this.selectedTableType === 1 ? "feeders" : "waterwises"] = this[
      this.selectedTableType === 1 ? "feeders" : "waterwises"
    ].map((item) => {
      return { ...item, status: false };
    });
  }

  validateButtonSubmit() {
    return this.globalFunction.validateButtonSubmitBatteryPanel(this.searchGraph.value);
  }
  validateTextAlert() {
    return this.globalFunction.validateTextAlertBatteryPanel(this.searchGraph.value);
  }

  validateShowModalBattery = async () => {
    let feeders = this.selectedItems.map((item) => {
      let color = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
      const { id, name } = item;
      return { id, name, color };
    });

    let global = this.globalFunction.validateNoRepeatByPropiety([...feeders], "id");
    this.feedersHome = global;
    if (global.length > 0) {
      await this.getGraph("battery", true);
      await this.getGraph("panel", false);
    }
  };

  chageSelect(t) {
    if (t === "M") this.searchGraph.controls["value_rule"].setValue("");
  }
  labelsBattery = [];
  dataBattery = [];
  dataGraph = {
    battery: {
      data: [],
      labels: []
    },
    panel: {
      data: [],
      labels: []
    }
  };
  getGraph = async (type: "battery" | "panel", modal: Boolean) => {
    const { resample_rule, value_rule, start_date, finish_date } = this.searchGraph.value;

    let query = `?id_in=${this.feedersHome.map(
      (item: any) => item.id
    )}&resample_rule=${value_rule}${resample_rule}${
      finish_date && start_date ? `&date_created=${start_date},${finish_date}` : ""
    }`;

    let data = await this.feedersService.GetStatusGraph(type, query).toPromise();
    if (data.length > 0) {
      let allDates: Array<any> = [];
      /* Hacemos un array global para almacenar todas las fechas */
      data.forEach((feeder) => {
        let labels = feeder.data.map((item) => moment(item.date).format("YYYY-MM-DD"));
        allDates = [...allDates, ...labels];
      });
      /* Quitamos todas las fechas repetidas */
      let unique = allDates.filter((elem, index, self) => index === self.indexOf(elem));

      let newArray = data.map((feeder) => {
        const { feeder_id } = feeder;
        const feed: any = this.feedersHome.find(
          (item: any) => Number(item.id) === Number(feeder_id)
        );

        return {
          data: feeder.data.map((item, idx) => {
            let date = moment(item.date).format("YYYY-MM-DD");
            let validate = unique.findIndex((element) => element === date);
            return validate !== -1 ? Number(item.value.toFixed(2)) : 0;
          }),
          type: "line",
          name: feed.name,
          color: feed.color
        };
      });
      this.dataGraph = {
        ...this.dataGraph,
        [type]: {
          data: newArray,
          labels: unique
        }
      };

      modal && this.showModal(this.modalBatteryPanel);
    }
  };
  deleteItem(i) {
    this.feedersHome.splice(i, 1);
    localStorage.setItem("feeders-home", JSON.stringify(this.feedersHome));
    this.getGraph("battery", false);
    this.getGraph("panel", false);
  }

  /**
   * Cierra el panel de alertas y opcionalmente deselecciona los equipos
   * según la configuración del usuario.
   */
  closePanel() {
    const shouldKeepSelected = this.storageService.localValue.keep_devices_selected;

    if (this.selectedTableType == 1) {
      this.viewModalPanel = false;
      if (!shouldKeepSelected) {
        this.selectedItems = [];
        this.feeders = this.feeders.map((item) => {
          return { ...item, status: false };
        });
      }
    }
    if (this.selectedTableType == 4) {
      this.viewModalTestDevice = false;
      if (!shouldKeepSelected) {
        this.selectedItems = [];
        this.waterwises = this.waterwises.map((item) => {
          return { ...item, status: false };
        });
      }
    }
  }
  validateBackgroundNav(sectionId: number, itemId: number) {
    if (!this.section) {
      return false;
    }

    // Check if current section matches the parent section of the active submenu item
    const parentSection = this.sections.find((s) =>
      s.submenu?.some((sub) => sub.id === this.section.id)
    );

    return parentSection?.id === itemId;
  }

  onSectionClick(item: any) {
    if (!item.submenu || item.submenu.length === 0) {
      this.section = item;
      this.view_mode = item.viewMode;
      if (item.viewMode === 3) {
        this.selectedFarmParametry();
      }
      if (!this.storageService.isAdmin()) {
        this.getSoloPonds();
      }
    }
  }

  onSubmenuClick(submenuItem: any, parentItem: any, event: Event) {
    event.stopPropagation();

    // Check if admin access is required
    if (submenuItem.requiresAdmin && !this.storageService.validateSoloAdmin()) {
      return;
    }

    this.changeTableType(submenuItem.tableType, submenuItem.id);

    if (parentItem.viewMode === 3) {
      this.selectedFarmParametry();
    }
    if (!this.storageService.isAdmin()) {
      this.getSoloPonds();
    }
    this.getData();
  }
  actionsMenu() {}

  /** Downloads the waterwise values report applying the active form filters.
   * Filters: client_id, farm_id, pond_id, cycle_id and created_at (date range).
   * When a date range is provided it takes precedence over cycle_id.
   */
  downloadWaterwiseValuesReport(): void {
    const { client_id, farm_id, pond_id, cycle_id, dateCreated, finishCreated } =
      this.FormSearch.value;

    const hasDateRange = dateCreated && finishCreated;

    const object_query: any = {
      client_id: client_id || undefined,
      farm_id: farm_id || undefined,
      pond_id: pond_id || undefined
    };

    if (hasDateRange) {
      object_query.created_at = `${dateCreated},${finishCreated}`;
    } else if (cycle_id) {
      object_query.cycle_id = cycle_id;
    }

    const query = this.globalFunction.constructQuery(object_query);

    this.alertsService
      .getWaterwiseValuesReport(query)
      .pipe(takeUntil(this.cancelDataRequests$))
      .subscribe(
        (resp: any) => {
          this.globalFunction.downloadFIle(resp.file_data, resp.filename, resp.extension);
        },
        () => {}
      );
  }
}
